







































import ActionButton from '@/components/ActionButton.vue'
import { TableHeader, Params } from '@/utils/interfaces'
import { Transaction } from '@/utils/interfaces/topup.interface'
import TransactionsDetailsButton from '@/components/Agency/Transactions/TransactionsDetailsButton.vue'
import { formatDate } from '@/utils/functions'
import TransactionsFilter from '@/components/Agency/Transactions/TransactionsFilter.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { getTransactions } from '@/api/Agency/agency.api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<Transaction>().extend({
  components: {
    appActionButton: ActionButton,
    TransactionsDetailsButton,
    appTransactionsFilter: TransactionsFilter,
    FlatCard,
    FlatTable,
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t('created_by'),
          value: 'created_by',
        },
        {
          text: this.$t('currency'),
          value: 'currency',
        },
        {
          text: this.$t('origin'),
          value: 'origin',
        },
        {
          text: this.$t('destiny'),
          value: 'destiny',
        },
        {
          text: this.$t('date'),
          value: 'created_at',
        },
        {
          text: this.$t('transfer-type'),
          value: 'type',
        },
        {
          text: this.$t('amount'),
          value: 'amount',
        },
        {
          text: this.$t('details'),
          value: 'details',
        },
      ] as TableHeader[],
      getter: (params?: Params) => {
        if (
          this.$store.getters.profile.role === 'ADMIN' &&
          !this.$store.getters.is_superuser
        ) {
          return getTransactions({ ...params, from_agency: true })
        } else return getTransactions(params)
      },
      detailsItem: null as null | Transaction,
      detailsDialog: false,
    }
  },
  methods: {
    onDetails(item: Transaction) {
      this.detailsItem = item
      this.detailsDialog = true
    },
    formatDate(date: string) {
      return formatDate(date)
    },
  },
})
